<template>
  <div>
    <div
      class="absolute top-0 left-0 right-0 bottom-0 z-10 flex flex-col bg-white sm:relative sm:bg-transparent"
      v-if="searching"
    >
      <div
        class="z-10 flex items-center justify-between border-b-hairline bg-white p-6 sm:border-b-0 sm:px-3 sm:py-0"
      >
        <span class="far fa-search mr-2 text-black"></span>
        <input
          ref="input"
          v-model="keyword"
          :placeholder="this.$t('global.search_placeholder')"
          class="w-48 flex-1 rounded-full bg-gray-300 px-4 py-1 text-black outline-none outline-brand-500 focus:ring md:w-56 lg:w-64"
          @keydown.esc="searching = false"
          @keydown.up="highlightPrevious"
          @keydown.down="highlightNext"
          @keydown.enter="selectHighlight"
        />
        <button class="sm:hidden" @click="searching = false">
          <span class="fal fa-times ml-6 text-xl text-black"></span>
        </button>
      </div>
      <ul
        ref="results"
        v-if="results !== null"
        class="flex-1 overflow-auto sm:absolute sm:left-0 sm:right-0 sm:top-0 sm:-mr-16 sm:mt-16 sm:rounded-lg sm:shadow-lg"
      >
        <li
          v-if="results.length == 0"
          class="bg-white px-6 py-3 text-lg italic text-gray-500 sm:px-4"
        >
          {{ this.$t('global.search_no_results') }}
        </li>
        <li
          class="border-b-hairline bg-white text-lg"
          :class="{
            'bg-white': highlightedIndex !== i,
            'bg-gray-100': highlightedIndex === i,
          }"
          v-for="(result, i) in results"
          :key="result.link"
        >
          <a
            :href="result.link"
            class="flex cursor-pointer flex-col px-6 py-3 leading-tight hover:bg-gray-300 sm:px-4"
          >
            <span class="mb-1 text-sm font-light text-brand-500">
              {{ result.category }}
            </span>
            <span class="text-black">
              {{ result.title }}
            </span>
            <span class="text-sm" v-if="result.details">
              {{ result.details }}
            </span>
          </a>
        </li>
      </ul>
    </div>
    <button
      class="rounded outline-none hover:text-black focus:ring"
      @click="searching = true"
      v-show="!searching"
    >
      <slot />
    </button>
  </div>
</template>

<script>
import { nextTick } from 'vue'
export default {
  data() {
    return {
      keyword: null,
      searching: false,
      highlightedIndex: -1,
      results: null,
    }
  },
  watch: {
    keyword(value) {
      this.debounceEntry(value)
    },
    searching(value) {
      if (value) {
        document.body.classList.add('overflow-hidden')
        document.body.classList.add('sm:overflow-auto')

        nextTick(() => {
          this.$refs.input.focus()
        })

        document.addEventListener('click', this.closeIfClickedOutside)
      } else {
        document.body.classList.remove('overflow-hidden')
        document.body.classList.remove('sm:overflow-auto')

        document.removeEventListener('click', this.closeIfClickedOutside)
      }
    },
  },
  methods: {
    highlight(index) {
      this.highlightedIndex = index
      this.$refs.results.children[index].scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      })
    },
    highlightPrevious() {
      if (this.highlightedIndex === 0) {
        return
      }

      this.highlight(this.highlightedIndex - 1)
    },
    highlightNext() {
      if (this.highlightedIndex >= this.results.length - 1) {
        return
      }

      this.highlight(this.highlightedIndex + 1)
    },
    selectHighlight() {
      if (this.highlightedIndex === -1) {
        return
      }

      document.location = this.results[this.highlightedIndex].link
    },
    closeIfClickedOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.searching = false
      }
    },
    debounceEntry(keyword) {
      if (keyword == '') {
        return
      }

      const _this = this
      _.debounce(() => {
        axios
          .get('/api/search', {
            params: {
              q: keyword,
            },
          })
          .then(({ data }) => {
            _this.results = data
          })
          .catch((error) => {
            _this.results = []
            console.log(error)
          })
          .finally(() => {
            _this.highlightedIndex = -1
          })
      }, 100)()
    },
  },
}
</script>
